import "@/helpers/turbo"
import CompetitionFormController from "../controllers/competition_form_controller"
import RecaptchaController from "../controllers/recaptcha_controller"

import InputValidityController from "../controllers/forms/input_validity_controller"

//import Recaptcha from "@/helpers/recaptcha"
import { application } from "@/helpers/stimulus"

const setupStimulus = (): void => {
  application.register("competition-form", CompetitionFormController)
  application.register("input-validity", InputValidityController)
  application.register("recaptcha", RecaptchaController)
}

setupStimulus()
